module.exports = __webpack_public_path__ + "static/media/9、国务院国资委中央企业国有资本经营预算拟支持重大项目预评估咨询-min.5b77db20.jpg";